import React from "react";
import {
  Route,
  Switch,
  Redirect,
  useParams,
  useRouteMatch,
} from "react-router";
import List from "./List";

const Functions = () => {
  const params: any = useParams();
  const match: any = useRouteMatch();
  const redirectUrl = match.path.replace(":appId", params.appId);

  return (
    <Switch>
      <Route exact path={match.path} component={List} />
      <Route component={() => <Redirect to={redirectUrl}/>} />
    </Switch>
  );
};

export default Functions
